import Vue from 'vue'
import  _ from 'lodash'
import { ADD_TYPE_LIST, ADD_TYPE } from '../../constant'

function createFormItem(formItemType, payload, next, parent) {
    const nextFunc = (current, acients) => {
        const formData = acients.reduce((acc, item) => {
            acc[item.payload.field] = item.payload.value;
            return acc;
        }, {});

        let nextItem = next(current, acients, formData);
        if (nextItem) {
            nextItem.parent = current;
        }
        return nextItem;
    };

    return {
        type: formItemType,
        payload: Vue.observable(payload),
        next: nextFunc,
        parent: parent || null
    };
} ;

export function createFormItemFactory({
    displayType,appList, vm
}) {
    const addTypeFormItem = createFormItem('WkListCheck', {
        value: vm.currentAddType || _.head(ADD_TYPE_LIST).value, // 默认值
        field: 'add_type', // 字段名
        label: '添加类型', // 标签名
        props: { // 组件属性
            list: ADD_TYPE_LIST, // 选项列表
        },
        berforeChange: (...args)=> vm.handleAddTypeBeforeChange(...args)
    }, (formState)=> {
        const { value } = formState.payload;
        if (value === ADD_TYPE.POSITION) {
            return displayTypeFormItem(displayType, appList.length)    
        }else {
            console.log(2, appList);
            return appListFormItem(appList, 1)
        }
    })
    const appListFormItem = (list, base)=> {
        return createFormItem('WkListCheck', {
            value: _.head(list).value,
            field: 'app_id',
            label: '产品',
            props: {
                list,
                label: '转化出价',
                base
            }
        }, (formState)=> {
            return displayTypeFormItem(displayType, base)
        })
    };
    const displayTypeFormItem =(list, base)=> {
        return  createFormItem('WkListCheck', {
                value: _.head(list).value,
                field: 'display_type',
                label: '版位',
                props: {
                    list: list,
                    label: '转化出价',
                    base
                }
            }, (formState, acients, formData)=> {
                vm.formDataChange(acients,formData)
               return null
        })
    };
    return addTypeFormItem;
};
export function observableMap(list, callback) {
    return list.map(item => Vue.observable( callback? callback(item) : item ))
}